import { createSelector } from '@reduxjs/toolkit'

const getUserAgreementsSlice = (state) => state.userAgreements

// Draft
export const getUserAgreementsDraftRequestStatus = (state) => getUserAgreementsSlice(state).draft.requestStatus

export const getUserAgreementsDraft = createSelector(
    [getUserAgreementsSlice],
    (userAgreementsSlice) => userAgreementsSlice.draft
)

// Accepted
export const getUserAgreementsRequestStatus = (state) => getUserAgreementsSlice(state).accepted.requestStatus

export const getUserAgreements = createSelector(
    [getUserAgreementsSlice],
    (userAgreementsSlice) => userAgreementsSlice.accepted
)
